'use client';

import { useRouter } from 'next/router';
import { useCreateSegmentFilters } from '@/creditflowresearch/application/PageFilters/hooks/create';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';
import { useCorporateAccessibleMarkets } from './useCorporateAccessibleMarkets';

export const useCorporateBondScreenerFilters = (): IFilterSet[] => {
  const { query } = useRouter();
  // TODO: remove when the European market opening period ends
  const markets = useCorporateAccessibleMarkets();
  const segments = useCreateSegmentFilters();

  return transformToFilterSets([
    { key: 'segments', items: segments, allowEmpty: true },
    { key: 'markets', items: markets },
  ], query);
};
